import { SERVER_API } from 'config';
import { ExchangeError } from '../ports/exchange';
export function createFetchExchangeAdapter() {
    return {
        async exchange(firebaseIdToken) {
            let response;
            try {
                response = await fetch(SERVER_API.url, {
                    method: 'POST',
                    headers: {
                        'X-Api-Key': SERVER_API.xApiKey,
                        'Content-Type': SERVER_API.contentType,
                    },
                    body: JSON.stringify({
                        scope: SERVER_API.scope,
                        idToken: firebaseIdToken,
                    }),
                });
            }
            catch (cause) {
                throw new ExchangeError({ kind: 'network' });
            }
            if (!response.ok) {
                const status = response.status;
                if (status === 404 || status === 410) {
                    throw new ExchangeError({ kind: 'deleted' });
                }
                if (status === 403 || status === 423) {
                    throw new ExchangeError({ kind: 'inactive' });
                }
                throw new ExchangeError({ kind: 'unexpected', status });
            }
            return response.json();
        },
    };
}
